/**
 * Strategy Trade Notifications WebSocket Channel
 * Subscribes to wallet-level strategy trade notifications via ActionCable
 */

import type { Subscription } from '@rails/actioncable';
import type { StrategyTradeNotification } from '@/types/api/quickTrade';
import { getAuthenticatedConsumer } from '@/services/websocket/consumer';

export class StrategyTradeNotificationsChannel {
  private subscription: Subscription | null = null;

  /**
   * Subscribe to strategy trade notifications for the authenticated wallet
   * @param onNotification - Callback for incoming notifications
   * @returns Unsubscribe function
   */
  subscribe(onNotification: (data: StrategyTradeNotification) => void): () => void {
    this.unsubscribe();

    this.subscription = getAuthenticatedConsumer().subscriptions.create(
      { channel: 'StrategyTradeNotificationsChannel' },
      {
        received(data: StrategyTradeNotification) {
          onNotification(data);
        },
        connected() {
          console.log('[StrategyTradeNotifications] Connected');
        },
        disconnected() {
          console.log('[StrategyTradeNotifications] Disconnected');
        },
      }
    );

    return () => this.unsubscribe();
  }

  unsubscribe(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
  }
}
